// ** React Imports
import { SyntheticEvent, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { styled } from '@mui/material/styles'
import MuiTab, { TabProps } from '@mui/material/Tab'

// ** Icons Imports
import LockOutline from 'mdi-material-ui/LockOutline'
import BellOutline from 'mdi-material-ui/BellOutline'
import LinkVariant from 'mdi-material-ui/LinkVariant'
import AccountOutline from 'mdi-material-ui/AccountOutline'
import BookmarkOutline from 'mdi-material-ui/BookmarkOutline'
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MessageList from './messaging/MessageList'
import SchemaIcon from '@mui/icons-material/Schema';
import PlaybookCadenceTemplateList from './template-library/PlaybookCadenceTemplateList'
import CadenceList from './cadences/CadenceList'

// ** Demo Components Imports

// ** Types



// ** Styled Tab component
const Tab = styled(MuiTab)<TabProps>(({ theme }) => ({
    minHeight: 48,
    flexDirection: 'row',
    '& svg': {
        marginBottom: '0 !important',
        marginRight: theme.spacing(3)
    }
}))


const PlaybookViewRight = () => {
    // ** State
    const [value, setValue] = useState<string>('messaging')

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue)
    }

    return (
        <TabContext value={value}>
            <TabList
                variant='scrollable'
                scrollButtons={true}
                allowScrollButtonsMobile
                onChange={handleChange}
                aria-label='forced scroll tabs example'
                sx={{ borderBottom: theme => `1px solid ${theme.palette.divider}` }}
            >
                <Tab value='messaging' label='Messaging' icon={<LocalLibraryIcon />} />
                <Tab value='templates' label='Template Library' icon={<ContentCopyIcon />} />
                <Tab value='cadences' label='Cadences' icon={<SchemaIcon />} />
            </TabList>
            <Box sx={{ mt: 6 }}>
                <TabPanel sx={{ p: 0 }} value='messaging'>
                    <MessageList />
                </TabPanel>
                <TabPanel sx={{ p: 0 }} value='templates'>
                    <PlaybookCadenceTemplateList />
                </TabPanel>
                <TabPanel sx={{ p: 0 }} value='cadences'>
                    <CadenceList />
                </TabPanel>
            </Box>

        </TabContext>
    )
}

export default PlaybookViewRight
